import { Link } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
const PackageTabs = (props) => {
  const { user } = useAuth();
  return (
    <ul
      className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3"
      role="tablist"
    >
      <li className="nav-item">
        <Link
          to={"/package"}
          className={
            props.pageName === "HOLIDAY PACKAGE"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          CREATE PACKAGE
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          to={"/packageslist"}
          className={
            props.pageName === "PACKAGES"
              ? "nav-link active bg-primary text-white"
              : "nav-link"
          }
        >
          PACKAGES
        </Link>
      </li>
       {user && user.isWebsite && (
        <li className="nav-item" role="presentation">
            <Link 
                to={"/websitepackages"} 
                className={props.pageName === "WEBSITEPACKAGES" ? "nav-link active bg-primary text-white" : "nav-link"}
            >
                WEBSITE PACKAGES
            </Link>
        </li>
      )}
      {/* <li className="nav-item">
                    <Link to={"/aisupplierpackage"} className={props.pageName === "AIPACKAGE BUILDER" ? "nav-link active bg-primary text-white" : "nav-link"}>AI PACKAGE BUILDER WITH SUPPLIER</Link>
                </li> */}
      
      {/* <li className="nav-item" role="presentation">
                    <Link to={"/enquirylist"} className={props.pageName === "ENQUIRIES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE ENQUIRIES</Link>
                </li> */}
      {/* <li className="nav-item" role="presentation">
                    <Link to={"/packagedates"} className={props.pageName === "PACKAGEDATES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE DATES</Link>
                </li> */}
    </ul>
  );
};

export default PackageTabs;
